/**
 * Helper function để thay đổi màu fill/stroke của SVG string
 * @param svgString - SVG string từ database
 * @param fillColor - Màu fill mới (ví dụ: "#1976d2")
 * @param strokeColor - Màu stroke mới (optional)
 * @returns SVG string với màu mới
 */
export const changeSvgColor = (
  svgString: string,
  fillColor: string,
  strokeColor?: string
): string => {
  if (!svgString) return svgString;

  let result = svgString;

  // Thay đổi fill attributes
  if (fillColor) {
    // Thay đổi fill attribute trong SVG
    result = result.replace(/fill="[^"]*"/g, `fill="${fillColor}"`);
    // Thay đổi style fill
    result = result.replace(/fill:\s*[^;"]*/g, `fill: ${fillColor}`);
  }

  // Thay đổi stroke attributes
  if (strokeColor) {
    result = result.replace(/stroke="[^"]*"/g, `stroke="${strokeColor}"`);
    result = result.replace(/stroke:\s*[^;"]*/g, `stroke: ${strokeColor}`);
  }

  return result;
};

/**
 * Alternative: Sử dụng CSS filter để thay đổi màu SVG
 * Cách này không thay đổi SVG string mà thay đổi qua CSS
 */
export const getSvgFilterStyle = (
  isActive: boolean,
  activeColor: string = "#1976d2"
) => {
  if (!isActive) return {};

  // Sử dụng filter + brightness để highlight SVG
  // Hoặc có thể sử dụng CSS mask/filter khác
  return {
    filter: `drop-shadow(0 0 2px ${activeColor})`
    // Hoặc: color: activeColor (nếu sử dụng currentColor)
  };
};
